<template>
  <el-scrollbar max-height="90%">
    <el-row>
      <el-col :span="24">
        <el-menu
          background-color="rgb(46,63,86)"
          text-color="rgb(187,190,191)"
          default-active="2"
          class="el-menu-vertical"
          @select="handleOpen"
          @close="handleClose"
          router
        >
          <!-- 一级菜单-首页 -->
          <el-menu-item index="index" class="index-menu">
            <el-icon :size="20">
              <el-icon>
                <HomeFilled style="color: rgb(187, 190, 191)" />
              </el-icon>
            </el-icon>
            <span class="font-set no-select">首页</span>
          </el-menu-item>
          <template v-for="menu in menusCache" :key="menu.resourceId">
            <template v-if="menu.children">
              <!-- 一级菜单 -->
              <el-sub-menu
                :index="menu.resourceUrl"
                class="menu-border no-select"
              >
                <template #title>
                  <el-icon :size="20">
                    <component
                      :is="getIcon(menu.resourceId)"
                      style="color: rgb(187, 190, 191)"
                    />
                  </el-icon>
                  <span class="font-set">{{ menu.resourceName }}</span>
                </template>
                <!-- 二级菜单 -->
                <el-menu-item-group>
                  <template
                    v-for="child in menu.children"
                    :key="child.resourceId"
                  >
                    <el-menu-item
                      :index="child.resourceUrl"
                      class="submenu-border font-set no-select"
                    >
                      {{ child.resourceName }}
                    </el-menu-item>
                  </template>
                </el-menu-item-group>
              </el-sub-menu>
            </template>
            <template v-else>
              <el-menu-item
                :index="menu.resourceUrl"
                :key="menu.resourceId"
                class="no-select"
              >
                <el-icon><icon-menu /></el-icon>
                <span class="link_text">{{ menu.resourceName }}</span>
              </el-menu-item>
            </template>
          </template>
          <el-menu-item index="file-browse" class="index-menu">
            <el-icon :size="20">
              <el-icon>
                <Briefcase style="color: rgb(187, 190, 191)" />
              </el-icon>
            </el-icon>
            <span class="font-set no-select">文件浏览</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </el-scrollbar>

  <div></div>
</template>

<script>
export default {
  data() {
    return {
      menus: [],
      class: "ArrowLeft",
      menuIconMap: [
        {
          resourceId: 10000,
          icon: "Ticket",
        },
        {
          resourceId: 20000,
          icon: "",
        },
        {
          resourceId: 30000,
          icon: "Opportunity",
        },
        {
          resourceId: 40000,
          icon: "Briefcase",
        },
        {
          resourceId: 50000,
          icon: "Tools",
        },
        {
          resourceId: 60000,
          icon: "Stamp",
        },
      ],
    };
  },
  name: "SideBar",
  components: {},
  props: {},
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    getIcon(resourceId) {
      for (var key in this.menuIconMap) {
        if (resourceId == this.menuIconMap[key].resourceId) {
          return this.menuIconMap[key].icon;
        }
      }
    },
  },
  computed: {
    menusCache() {
      // console.log("菜单缓存计算属性");
      // console.log(this.$store.getters.getMenus);
      // return this.$store.getters.getMenus;
      return JSON.parse(sessionStorage.getItem("menus"));
    },
  },
  created() {
    // console.log("菜单栏created");
    // console.log(this.menusCache);
    // this.menus = this.$store.getters.getMenus;
    // this.menus = sessionStorage.getItem("menus");
  },
};
</script>

<style scoped lang="scss">
.index-menu {
  // border: solid 2px;
  // border-left: 0px;
  // border-right: 0px;
  border-color: rgb(189, 197, 205, 0.2);
}

.menu-border {
  // border: solid 2px;
  // border-top: 0px;
  // border-left: 0px;
  // border-right: 0px;
  border-color: rgb(189, 197, 205, 0.2);
}

.submenu-border {
  // border: solid 1px;
  // border-bottom: 0px;
  // border-left: 0px;
  // border-right: 0px;
  border-color: rgb(189, 197, 205, 0.2);
  background-color: rgb(31, 45, 61);
}

.el-menu-item:hover {
  background-color: rgb(38, 52, 69);
}

.submenu-border:hover {
  background-color: rgb(0, 21, 40);
}
.font-set {
  font-weight: normal;
}

.no-select {
  // 解决了光标闪动问题和菜单栏文字被选中的不美观问题
  user-select: none;
}

// 图标颜色#73767a
</style>
